var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1289,
    height: 849,
    viewBox: "0 0 1289 849",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_46_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.58 459.998C1332.23 193.515 665.196 74.9647 300.85 49C584.732 92.0543 1100.87 230.338 894.373 439.038C687.875 647.738 -154.583 686.128 -550 679.235C-107.579 717.191 838.924 726.482 1085.58 459.998Z",
    fill: "#F68500",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_46_152",
    x: -700,
    y: -101,
    width: 1989,
    height: 950,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_46_152"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGradient);
export default __webpack_public_path__ + "static/media/background-gradient.cf3a70204253d89d5598dbe58c99cc15.svg";
export { ForwardRef as ReactComponent };